<template>
    <div>
      <Pos_invoices_tax_refund_edit/>
    </div>
  </template>
  
  <script>
  import Pos_invoices_tax_refund_edit from "@/components/adminArin/pos_system/pos/Pos_invoices_tax_refund_edit";
  export default {
    name: "PosInvoicesTaxRefundEdit",
    components: {
      Pos_invoices_tax_refund_edit
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  